import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=ccd7593e&scoped=true&"
import script from "./MessageBubble.vue?vue&type=script&lang=js&"
export * from "./MessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=ccd7593e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd7593e",
  null
  
)

export default component.exports